/* ===== Product Detail Page JS ===== */
(function () {
  'use strict';

  /* ---------- Gallery Hover Zoom ---------- */
  function initHoverZoom() {
    document.querySelectorAll('.pdp__tile').forEach(function (tile) {
      var img = tile.querySelector('.pdp__tile-img');
      if (!img) return;

      tile.addEventListener('mousemove', function (e) {
        var rect = tile.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });

      tile.addEventListener('mouseleave', function () {
        img.style.transformOrigin = '50% 50%';
      });
    });
  }

  /* ---------- Gallery Navigation Arrows ---------- */
  function initGalleryNav() {
    var gallery = document.querySelector('.pdp__gallery');
    var prevBtn = document.querySelector('.pdp__gallery-arrow--prev');
    var nextBtn = document.querySelector('.pdp__gallery-arrow--next');
    if (!gallery || !prevBtn || !nextBtn) return;

    function updateArrows() {
      var scrollLeft = gallery.scrollLeft;
      var maxScroll = gallery.scrollWidth - gallery.clientWidth;
      prevBtn.disabled = scrollLeft <= 2;
      nextBtn.disabled = scrollLeft >= maxScroll - 2;
    }

    // Reset scroll to start and update arrows
    gallery.scrollLeft = 0;
    updateArrows();
    gallery.addEventListener('scroll', updateArrows, { passive: true });

    prevBtn.addEventListener('click', function() {
      var tiles = gallery.querySelectorAll('.pdp__tile');
      if (!tiles.length) return;
      gallery.scrollBy({ left: -tiles[0].offsetWidth, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function() {
      var tiles = gallery.querySelectorAll('.pdp__tile');
      if (!tiles.length) return;
      gallery.scrollBy({ left: tiles[0].offsetWidth, behavior: 'smooth' });
    });
  }

  /* ---------- Color Swatch — Sibling Product Switching ---------- */
  function initSwatches() {
    var section = document.querySelector('[data-pdp-section]');
    if (!section) return;

    var sectionWrapper = section.closest('[id^="shopify-section-"]');
    var sectionId = sectionWrapper
      ? sectionWrapper.id.replace('shopify-section-', '')
      : null;

    var swatches = section.querySelectorAll('.pdp__swatch[data-product-handle]');
    if (!swatches.length) return;

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (this.classList.contains('is-active')) return;

        var handle = this.dataset.productHandle;
        var productUrl = '/products/' + handle;
        var fetchUrl = sectionId
          ? productUrl + '?section_id=' + sectionId
          : productUrl;

        // Loading state
        section.style.opacity = '0.5';
        section.style.pointerEvents = 'none';

        fetch(fetchUrl)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            if (sectionId) {
              // Section Rendering API — returns section HTML directly
              sectionWrapper.innerHTML = html;
            } else {
              // Fallback — parse full page, extract section
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var newSection = doc.querySelector('[data-pdp-section]');
              if (newSection && sectionWrapper) {
                sectionWrapper.innerHTML = newSection.parentElement.innerHTML;
              }
            }

            // Update URL without reload
            history.replaceState({ handle: handle }, '', productUrl);

            // Re-initialize all JS behaviors
            initHoverZoom();
            initGalleryNav();
            initSwatches();
            restoreWishlistState();
          })
          .catch(function () {
            // Revert loading state on error
            section.style.opacity = '1';
            section.style.pointerEvents = '';
          });
      });
    });
  }

  /* ---------- Wishlist State Restore ---------- */
  function restoreWishlistState() {
    var section = document.querySelector('[data-pdp-section]');
    if (!section) return;

    var btn = section.querySelector('.pdp__wishlist');
    if (!btn) return;

    var onclickStr = btn.getAttribute('onclick') || '';
    var idMatch = onclickStr.match(/var id='(\d+)'/);
    if (!idMatch) return;

    var productId = idMatch[1];
    var w = JSON.parse(localStorage.getItem('wishlist') || '[]');
    if (w.length > 0 && typeof w[0] === 'string') return;

    if (w.findIndex(function (x) { return x.id === productId; }) > -1) {
      var svg = btn.querySelector('svg');
      if (svg) {
        svg.style.fill = '#E53935';
        svg.style.stroke = '#E53935';
      }
    }
  }

  /* ---------- Initialize ---------- */
  initHoverZoom();
  initGalleryNav();
  initSwatches();

  /* ---------- Handle browser back/forward ---------- */
  window.addEventListener('popstate', function () {
    location.reload();
  });
})();
